module.exports = __webpack_public_path__ + "img/AG.a08ddafa.png";